// match height

$(function ($) {
$(window).on('load',function() {
equalheight('.collection-info');
});

$(window).on('resize',function() {
equalheight('.collection-info');
});
});

// match height End

$('.branad_inner').slick({
  dots: false,
  arrows:false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        autoplay: true,
		autoplaySpeed: 2000,
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        autoplay: true,
  		autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        autoplay: true,
  		autoplaySpeed: 2000,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


jQuery(".footer-block__heading").click(function(){
	  if($(window).width() <= '991'){
	  if(jQuery(this).hasClass("show"))
			{
	          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
	  else
			{
	          jQuery(".footer-block__heading").removeClass("show");
	          jQuery(".footer-block__heading").next().slideUp();
	          jQuery(this).addClass("show");jQuery(this).next().slideDown();
	        }
	    }
	});

$(window).scroll(function(){
	if ($(this).scrollTop() > 205) {
		$('header').addClass('fixed-header');
	} else {
		$('header').removeClass('fixed-header');
	}
});
